import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { FC } from 'react';
import { FlexColumn } from '../../basic-flex/flex-column';
import { DistriwinAllAnimalsHeader } from './distriwin-all-animals-header';
import {
	DistriwinAllAnimalsWorkListTableItem,
	IDistriwinAllAnimalsListSetting,
	IDistriwinValveAdjustments,
	PenAndCurve,
} from 'shared/api/api';
import { useDispatch, useSelector } from 'react-redux';
import { DistriwinAllAnimalsTable } from './distriwin-all-animals-table';
import { WebAppState } from 'web/state/store.web';
import { GetDistriwinAllAnimalsWorklistPdf } from 'web/web-helpers/pdf-helper/work-list-pdf-helper';
import { UpdateDistriwinValveAdjustments } from 'shared/state/ducks/retry-adjust-feed/operations';

interface Props {
	setting: IDistriwinAllAnimalsListSetting;
	ref?: any;
}

export const DistriwinAllAnimalsOverview: FC<Props> = React.memo(
	forwardRef(({ setting }, ref) => {
		const dispatch = useDispatch();
		const [sectionId, setSectionId] = React.useState<string>('');
		const [penIds, setPenIds] = React.useState<string[]>([]);
		const [filteredData, setFilteredData] = React.useState<DistriwinAllAnimalsWorkListTableItem[]>([]);
		const [selected, setSelected] = useState<DistriwinAllAnimalsWorkListTableItem[]>([]);
		const profile = useSelector((state: WebAppState) => state.profile.active!);
		const skioldRef = useRef<any>(null);
		const print = useCallback(async () => {
			await GetDistriwinAllAnimalsWorklistPdf(
				filteredData,
				'DistriwinAllAnimalsWorklist.pdf',
				profile.siteId!,
				Intl.DateTimeFormat().resolvedOptions().timeZone,
				profile.language,
			);
		}, [dispatch, filteredData, profile]);

		const updatePens = useCallback(async () => {
			let distriwinAdjustment = {
				siteId: profile.siteId,
				penIds: [] as PenAndCurve[],
			} as IDistriwinValveAdjustments;
			selected.forEach(x => {
				if (x.penId && distriwinAdjustment.penIds) {
					distriwinAdjustment.penIds.push({ penId: x.penId } as PenAndCurve);
				}
			});
			dispatch(UpdateDistriwinValveAdjustments(distriwinAdjustment));
		}, [dispatch, selected]);
		useImperativeHandle(
			ref,
			() => ({
				print() {
					print();
				},
				resend() {
					updatePens();
					if (skioldRef.current) {
						skioldRef.current.ResetSelected([]);
					}
				},
			}),
			[print, updatePens],
		);

		const onChangeSection = useCallback((sectionId: string, penIds: string[]) => {
			setSectionId(sectionId);
			setPenIds(penIds);
		}, []);

		return (
			<FlexColumn>
				<DistriwinAllAnimalsHeader onChangeSection={onChangeSection} />
				<DistriwinAllAnimalsTable
					skioldRef={skioldRef}
					setFilteredData={setFilteredData}
					setSelected={setSelected}
					penIds={penIds}
					sectionId={sectionId}
				/>
			</FlexColumn>
		);
	}),
);
